import bem from "easy-bem";
import type { StatusRestriction } from "features/restrictions/data/types";
import React from "react";
import { formatDate } from "utils/basic";

import "./BlockScreen.css";

const cn = bem("block-screen");

type BlockScreenProps = {
  restriction: StatusRestriction;
};

const BlockScreen: React.FC<BlockScreenProps> = ({ restriction }) => (
  <div className={cn()}>
    <div className={cn("content")}>
      <div className={cn("icon")}>⛔</div>
      <h1 className={cn("title")}>Аккаунт заблокирован</h1>

      <p className={cn("detail")}>
        Тип:{" "}
        {restriction.isPermanent
          ? "Постоянная блокировка"
          : "Временная блокировка"}
      </p>

      {restriction.expiresAt && (
        <p className={cn("detail")}>
          Срок: до {formatDate(restriction.expiresAt)}
        </p>
      )}

      {restriction.reason && (
        <p className={cn("detail")}>Причина: {restriction.reason}</p>
      )}

      <a
        className={cn("link")}
        href="/#/profile"
      >
        Обсудить с модератором
      </a>
    </div>
  </div>
);

export default BlockScreen;
